import { Config } from "common/config";
import { EColors } from "common/styles";
import { SpanColor } from "components/SpanColor";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import { Component } from "./components";
import { StyledTitle } from "./styled";

export const Benefits = () => {
  return (
    <Styled.Section color={EColors.bg_light} id={Config.Section.benefits}>
      <Styled.Container>
        <Fade direction="up" triggerOnce>
        <StyledTitle>
            <SpanColor bgColor={EColors.primary_200}>Переваги</SpanColor> нашого пального
          </StyledTitle>
        </Fade>
        <Component.BenefitsList />
      </Styled.Container>
    </Styled.Section>
  );
};
